import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import { DragSource, DropTarget } from 'react-dnd';
import {GridTile} from 'material-ui/GridList';
import IconButton from 'material-ui/IconButton';
import DeleteIcon from 'material-ui/svg-icons/action/delete';

import utils from '../misc/utils';
var config = utils.getConfig();

const ImageSource = {
  beginDrag(props) {
    return {
      id: props.index,
      index: props.index,
    };
  }  
}

const ImageTarget = {
  hover(props, monitor, component) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;

    if (dragIndex === hoverIndex) {
      return;
    }
    const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();    
    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
    const clientOffset = monitor.getClientOffset();    
    const hoverClientY = clientOffset.y - hoverBoundingRect.top;
    
    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
      return;
    }

    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
      return;
    }

    props.moveImage(dragIndex, hoverIndex);
    monitor.getItem().index = hoverIndex;
  },
};

@DropTarget('Image', ImageTarget, connect => ({
  connectDropTarget: connect.dropTarget(),
}))
@DragSource('Image', ImageSource, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging(),
}))
class DraggableImageCard extends Component {
  render() {    
    const { image, deletePictureAction, isDragging, connectDragSource, connectDropTarget } = this.props;
    const opacity = isDragging ? 0 : 1;

    var gridTitle = (
      <GridTile 
        key={image.ID}
        title=' '
        titleBackground="linear-gradient(to top, rgba(0,0,0,0.7) 0%,rgba(0,0,0,0.3) 70%,rgba(0,0,0,0) 100%)"
        style={{ opacity }}
        actionIcon={<IconButton onTouchTap={() => deletePictureAction(image)}><DeleteIcon color="white" /></IconButton>}>
        <img src={config.webApiUrl + 'api/images/' + image.ImageName} style={{width: '100%', height: '100%', objectFit: 'contain'}} />
      </GridTile>
    );

    return React.cloneElement(gridTitle, {
        ref: (instance) => {
          connectDropTarget(findDOMNode(instance));
          connectDragSource(findDOMNode(instance));
        }
    });
/*
    return connectDragSource(connectDropTarget(
      <div style={{ opacity }}>
        <GridTile 
          key={image.ID}
          title=' '
          titleBackground="linear-gradient(to top, rgba(0,0,0,0.7) 0%,rgba(0,0,0,0.3) 70%,rgba(0,0,0,0) 100%)"
          actionIcon={<IconButton onTouchTap={() => deletePictureAction(image)}><DeleteIcon color="white" /></IconButton>}>
          <img src={config.webApiUrl + 'api/images/' + image.ImageName} style={{width: '100%', height: '100%', objectFit: 'contain'}} />
        </GridTile>
      </div>
    ));   */     
  }
}

export default DraggableImageCard;


/** WEBPACK FOOTER **
 ** ./src/app/components/draggableImageCard.js
 **/